import simplify from '@turf/simplify'
import { lineString } from '@turf/helpers'

/**
 * @param qualityPercent 100 = return coords unchanged; lower = Turf simplify with larger tolerance (degrees).
 * Note: `createLineBufferGeometryCache().getSimplified` bypasses this entirely when quality ≥ 100.
 */
export function simplifyLineStringCoordinates(
  coords: [number, number][],
  qualityPercent: number
): [number, number][] {
  if (qualityPercent >= 100 || coords.length < 3) {
    return coords
  }
  const line = lineString(coords)
  const tolerance = ((100 - qualityPercent) / 100) ** 1.4 * 0.0012
  try {
    const out = simplify(line, { tolerance, highQuality: true })
    if (out.geometry.type !== 'LineString') return coords
    const c = out.geometry.coordinates as [number, number][]
    return c.length >= 2 ? c : coords
  } catch {
    return coords
  }
}
